import InflectTablesModel from 'models/InflectTablesModel';
import { get, put } from 'services/request';
import BaseInflectsModel, { IInflectBase } from './BaseInflectsModel';

type IActiveInflect = IInflectBase & {
  active: boolean;
};

export default class ActiveInflectTemplatesActiveModel extends BaseInflectsModel<IActiveInflect> {
  withInitials = true;
  templateId = 0;
  wordClassId = 0;

  // Override to exclude inflect -1 (CL Fix) as it's always included by backend
  getTableCells() {
    const cells = super.getTableCells();
    return cells.filter((cell) => cell.id !== -1);
  }

  setTemplateId(templateId: number) {
    this.templateId = templateId;
  }

  async loadTemplate(templateId: number, wordClassId: number) {
    if (templateId <= 0) {
      return;
    }
    await super.loadItemEdit(wordClassId);
    this.loadingItem = true;
    this.render();

    this.templateId = templateId;
    this.wordClassId = wordClassId;

    this.inflectTablesModel = new InflectTablesModel({
      courseId: this.courseId,
      wordClass: wordClassId,
    });

    await Promise.all([
      this.inflectTablesModel.getInflectTables(),
      this.inflectTablesModel.getInflectTableHeaders(),
      this.inflectTablesModel.getInflectTableCells(),
    ]);

    const items = await get<IActiveInflect[]>(`active-inflect-templates/${templateId}/active-inflects`);
    await this.setItem(this.fillInflects(items));

    this.loadingItem = false;
    this.render();
  }

  async save() {
    if (!this.templateId || !this.itemUpdated) {
      console.error('No template ID or items to save');
      return;
    }

    this.loadingItem = true;
    this.render();

    // Transform data for API - convert inflectId to inflectCellId and only send active items
    const itemsToSend = this.itemUpdated
      .filter((item: IActiveInflect) => item.active)
      .map((item: IActiveInflect) => ({
        inflectCellId: item.inflectId,
        active: true,
      }));

    await put(`active-inflect-templates/${this.templateId}/items`, {
      items: JSON.stringify(itemsToSend),
    });

    await this.loadTemplate(this.templateId, this.wordClassId);
  }

  protected createEmptyItem(inflectId: number, index = 0): IActiveInflect {
    return {
      index,
      inflectId,
      active: false,
    };
  }

  isInflectEmpty(item: IActiveInflect): boolean {
    return !item.active;
  }
}
